<!-- <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="readonly"
    (activeIndexChange)="activeIndexChanged.emit($event + 1);"></p-steps> -->

    <p-steps [model]="items" [readonly]="isReadonly?true:false" [activeIndex]="activeIndex" (activeIndexChange)="activeIndexChanged.emit($event + 1)"></p-steps>
